// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NewsList_card__h\\+DVt {
  background: var(--card);
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(13, 38, 63, 0.06);
  padding: 16px;
}

.NewsList_header__rTjL9 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.NewsList_btn__SA\\+dD {
  background: var(--bg);
  color: #fff;
  border: 0;
  border-radius: 10px;
  padding: 10px 14px;
  cursor: pointer;
}
.NewsList_btn__SA\\+dD.NewsList_ghost__dW4S5 {
  background: transparent;
  color: var(--bg);
  border: 1px solid var(--bg);
}
.NewsList_btn__SA\\+dD.NewsList_red__z1V1o {
  background: var(--accent);
}

.NewsList_table__tj98U {
  width: 100%;
  border-collapse: collapse;
}
.NewsList_table__tj98U th, .NewsList_table__tj98U td {
  padding: 10px 12px;
  border-bottom: 1px solid var(--border);
  text-align: left;
}
.NewsList_table__tj98U th {
  font-weight: 600;
  color: #556;
}

.NewsList_badge__3dSy0 {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  background: #eef3ff;
  color: #264;
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/modules/news/NewsList.module.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;EACA,mBAAA;EACA,8CAAA;EACA,aAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AACF;;AAEA;EACE,qBAAA;EACA,WAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AACF;AACE;EACE,uBAAA;EACA,gBAAA;EACA,2BAAA;AACJ;AAEE;EACE,yBAAA;AAAJ;;AAIA;EACE,WAAA;EACA,yBAAA;AADF;AAGE;EACE,kBAAA;EACA,sCAAA;EACA,gBAAA;AADJ;AAIE;EACE,gBAAA;EACA,WAAA;AAFJ;;AAMA;EACE,qBAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;AAHF","sourcesContent":[".card {\r\n  background: var(--card);\r\n  border-radius: 16px;\r\n  box-shadow: 0 10px 30px rgba(13, 38, 63, .06);\r\n  padding: 16px;\r\n}\r\n\r\n.header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.btn {\r\n  background: var(--bg);\r\n  color: #fff;\r\n  border: 0;\r\n  border-radius: 10px;\r\n  padding: 10px 14px;\r\n  cursor: pointer;\r\n\r\n  &.ghost {\r\n    background: transparent;\r\n    color: var(--bg);\r\n    border: 1px solid var(--bg);\r\n  }\r\n\r\n  &.red {\r\n    background: var(--accent);\r\n  }\r\n}\r\n\r\n.table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n\r\n  th, td {\r\n    padding: 10px 12px;\r\n    border-bottom: 1px solid var(--border);\r\n    text-align: left;\r\n  }\r\n\r\n  th {\r\n    font-weight: 600;\r\n    color: #556;\r\n  }\r\n}\r\n\r\n.badge {\r\n  display: inline-block;\r\n  padding: 2px 8px;\r\n  border-radius: 999px;\r\n  background: #eef3ff;\r\n  color: #264;\r\n  font-size: 12px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `NewsList_card__h+DVt`,
	"header": `NewsList_header__rTjL9`,
	"btn": `NewsList_btn__SA+dD`,
	"ghost": `NewsList_ghost__dW4S5`,
	"red": `NewsList_red__z1V1o`,
	"table": `NewsList_table__tj98U`,
	"badge": `NewsList_badge__3dSy0`
};
export default ___CSS_LOADER_EXPORT___;
